import { defineComponent as _defineComponent } from 'vue';
import { useAttrs } from 'vue';
import { cva } from 'class-variance-authority';
import { cn } from '../utils';
export default /*@__PURE__*/ _defineComponent({
    ...{ inheritAttrs: false },
    __name: 'Input',
    props: {
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true },
        focused: { type: Boolean, required: false },
        hasError: { type: Boolean, required: false },
        disabled: { type: Boolean, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const attrs = useAttrs();
        const inputWrapperVariants = cva('flex h-9 w-full items-center rounded-md border border-input bg-transparent px-3 shadow-xs transition-colors', {
            variants: {
                focused: { true: '', false: '' },
                hasError: { true: 'border-destructive ring-[0.5px] ring-destructive', false: '' },
                disabled: { true: 'cursor-not-allowed opacity-50', false: '' },
            },
            compoundVariants: [
                { focused: true, hasError: false, class: 'ring-2 ring-ring' },
            ],
        });
        const __returned__ = { props, attrs, inputWrapperVariants, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
